module.exports = __webpack_public_path__ + "media/os/windows-30078182.svg";